import axios, { AxiosRequestConfig } from "axios";
import { ImportJob } from "../models/import-job";
import { LpCount, LpFilter, LpWhere } from "../models/lp-filter";
import client from "./base"

export interface PresignedUrl {
    preSignedUrl: string;
    key: string;
}

export const getRequiredHeaders = async (adminId: number) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/import-jobs/required-headers`

    return client.get<string[]>(path);
}

export const getUploadPresignedUrl = async (adminId: number, pharmacyId: number, fileName: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/pharmacies/${pharmacyId}/import-jobs/upload-pre-signed-url`


    return client.post<PresignedUrl>(path, { fileName });
}

export const getReadPresignedUrl = async (adminId: number, pharmacyId: number, fileKey: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/pharmacies/${pharmacyId}/import-jobs/read-file-pre-signed-url`


    return client.post<PresignedUrl>(path, { fileKey });
}

export const uploadFileToS3 = async (preSignedUrl: string, file: File, options: AxiosRequestConfig) => {
    const newClient = axios.create();

    return newClient.put(preSignedUrl, file, options)
}

export const importInventoryData = async (adminId: number, pharmacyId: number, fileUrl: string, fileName: string, pharmacyName: string) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/pharmacies/${pharmacyId}/import-jobs`

    return client.post<any>(path, { fileName, fileUrl, pharmacyName });
}

export const getImportJobs = async (adminId: number, filter: LpFilter) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/import-jobs?filter=${JSON.stringify(filter)}`

    return client.get<ImportJob[]>(path);
}

export const getImportJobsCount = async (adminId: number, where: LpWhere) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/import-job/admins/${adminId}/import-jobs/count?where=${JSON.stringify(where)}`

    return client.get<LpCount>(path);
}